import { ICartState } from "@/interfaces/cart.interface";
import { atom, RecoilState } from "recoil";

export const cartState: RecoilState<ICartState> = atom({
  key: "cart",
  default: { updated_at: null, papers: [] },
});

export const cartSelectedIdsState: RecoilState<string[]> = atom({
  key: "cartIds",
  default: [],
});

export const contentListIdsState: RecoilState<string[]> = atom({
  key: "contentListIds",
  default: [],
});
